module.exports = __webpack_public_path__ + "static/media/MarketAccess.f9fd22f6.svg";